export const LIQUIDATION_WARNING_THRESHOLDS = [0.7, 0.75, 0.8, 0.85, 0.9, 0.95];
export const DEFAULT_SLIPPAGE = 0.75;

export const IMR_LIQUIDATION_THRESHOLD = 1;
